import { MutationCache, QueryCache, QueryClient, QueryClientProvider as Provider } from '@tanstack/react-query';
import { FC, PropsWithChildren } from 'react';
import { BadResponseError, UnauthorizedError } from '@/common/http';

const white_list = new Set(['/signin', '/cognito_callback']);

const handleError = (error: unknown) => {
  const is_public_path = white_list.has(window.location.pathname);
  if (error instanceof UnauthorizedError && !is_public_path) {
    window.location.replace('/signin');
  }
};

const throwOnError = (error: unknown) => error instanceof BadResponseError;

const client = new QueryClient({
  queryCache: new QueryCache({ onError: handleError }),
  mutationCache: new MutationCache({ onError: handleError }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
      throwOnError,
    },
    mutations: {
      throwOnError,
    },
  },
});

export const QueryClientProvider: FC<PropsWithChildren> = ({ children }) => {
  return <Provider client={client}>{children}</Provider>;
};
